import React from 'react';
import { useLocation } from '@reach/router';

import Caret from '../../assets/icons/caret.svg';
import CustomLink from '../customLink/CustomLink';

export const DE_LINKS = {
	'/en/': '/',
	'/en/carrers/': '/de/karriere/',
	'/en/training-contents/': '/de/ausbildungsinhalte/',
	'/en/about-us/': '/de/uber-uns/',
	'/en/quality-certifications/': '/de/qualitat-zertifizierungen/',
	'/en/contact-persons/': '/de/unsere-ansprechpartner/',
	'/en/webinar/': '/de/webinar/',
	'/en/newsletter/': '/de/newsletter/',
	'/en/contact/': '/de/kontakt/',
	'/en/services/': '/de/leistungen/',
	'/en/services/flame-cut-parts/': '/de/leistungen/brennteile/',
	'/en/services/welded-components/': '/de/leistungen/schweissbaugruppen/',
	'/en/services/all-round-consulting/': '/de/leistungen/komplette-losungen/',
	'/en/services/steel-trading/': '/de/leistungen/handel/',
	'/en/services/defense-solutions/': '/de/leistungen/defense-losungen/',
	'/en/privacy-policy/': '/de/datenschutzerklaerung/',
	'/en/imprint/': '/de/impressum/',
	'/en/technologies/': '/de/technologien/',
	'/en/apply-for-job/': '/de/bewerbung/',
	'/en/general-terms-and-conditions/': '/de/agb/',
	'/en/purchasing-conditions/': '/de/einkaufsbedingungen/',
};
export const EN_LINKS = {
	'/': '/en/',
	'/de/karriere/': '/en/carrers/',
	'/de/ausbildungsinhalte/': '/en/training-contents/',
	'/de/uber-uns/': '/en/about-us/',
	'/de/qualitat-zertifizierungen/': '/en/quality-certifications/',
	'/de/unsere-ansprechpartner/': '/en/contact-persons/',
	'/de/webinar/': '/en/webinar/',
	'/de/newsletter/': '/en/newsletter/',
	'/de/kontakt/': '/en/contact/',
	'/de/leistungen/': '/en/services/',
	'/de/leistungen/brennteile/': '/en/services/flame-cut-parts/',
	'/de/leistungen/schweissbaugruppen/': '/en/services/welded-components/',
	'/de/leistungen/komplette-losungen/': '/en/services/all-round-consulting/',
	'/de/leistungen/handel/': '/en/services/steel-trading/',
	'/de/leistungen/defense-losungen/': '/en/services/defense-solutions/',
	'/de/datenschutzerklaerung/': '/en/privacy-policy/',
	'/de/impressum/': '/en/imprint/',
	'/de/technologien/': '/en/technologies/',
	'/de/bewerbung/': '/en/apply-for-job/',
	'/de/agb/': '/en/general-terms-and-conditions/',
	'/de/einkaufsbedingungen/': '/en/purchasing-conditions/',
};

interface Props {
	langKey: 'en' | 'de';
}

const LangSwitch = ({ langKey }: Props) => {
	const { pathname } = useLocation();

	return (
		<div className="lang-switch py-30">
			<div className="switch-title row">
				{data.language[langKey]}
				<div className="row align-center justify-center icon">
					<Caret />
				</div>
			</div>

			<div className="switch-wrapper">{data.switch[langKey]?.(pathname)}</div>
		</div>
	);
};

export default LangSwitch;

const data = {
	language: {
		de: (
			<p className="country-flag-de active">
				<span className="germany">DE</span>
			</p>
		),
		en: (
			<p className="country-flag-en active">
				<span className="england">EN</span>
			</p>
		),
	},
	switch: {
		de: (pathname: string) => (
			<div className="switch-dropdown country-flag-en">
				<CustomLink href={EN_LINKS[pathname as keyof typeof EN_LINKS] || ''} title="EN" type="text" />
			</div>
		),
		en: (pathname: string) => (
			<div className="switch-dropdown country-flag-de">
				<CustomLink href={DE_LINKS[pathname as keyof typeof DE_LINKS] || ''} title="DE" type="text" />
			</div>
		),
	},
};
